import type { AppInfoApiService, AppInfoModel } from './AppInfoApiService'
import type { IAppLifecycleService } from '../core/lifecycle/AppLifecycleService'
import { BehaviorSubject } from 'rxjs'
import type { IBehaviorObservable } from '../common/react/IBehaviorObservable'

export class AppInfoService {
  public readonly serverInfo$: IBehaviorObservable<AppInfoModel | undefined>
  private readonly serverInfoSubject: BehaviorSubject<AppInfoModel | undefined>

  constructor(
    private readonly appInfoApiService: AppInfoApiService,
    private readonly appLifecycleService: IAppLifecycleService,
  ) {
    this.serverInfoSubject = new BehaviorSubject<AppInfoModel | undefined>(undefined)
    this.serverInfo$ = this.serverInfoSubject

    this.appLifecycleService.onInit$.subscribe(() => void this.fetchServerInfo())
  }

  private async fetchServerInfo(): Promise<void> {
    const { result, error } = await this.appInfoApiService.getServerAppInfo()
    if (error) {
      return
    }
    this.serverInfoSubject.next(result)
  }
}
